<template>
  <div class="results-list" :aria-busy="isFetching">
    <div
      class="results"
      :key="condamnation.id"
      v-for="condamnation in PaginationCond"
    >
      <ul>
        <li class="small meta" v-if="condamnation.Date_infraction">
          Date de l’infraction :
          {{
            condamnation.Date_infraction.toString().substring(0, 10)
          }}&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;
        </li>
        <li class="small meta" v-if="condamnation.Date_jugement">
          Date du jugement :
          {{
            condamnation.Date_jugement.toString().substring(0, 10)
          }}&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;
        </li>
        <li
          class="small meta"
          v-if="condamnation.SOC_DESC_POURS == 'VILLE DE MONTREAL'"
        >
          Poursuivant : Cour municipale de Montréal
        </li>
        <li class="small meta" v-if="condamnation.SOC_DESC_POURS == 'MAPAQ'">
          Poursuivant : Palais de justice de Québec
        </li>
      </ul>
      <hgroup
        v-if="
          condamnation.Raison_sociale !=null && condamnation.Nom_exploitant != null
        "
      >
        <span>{{ condamnation.Nom_exploitant }}</span>
        <h3>{{ condamnation.Raison_sociale }}</h3>
      </hgroup>
      <hgroup
        v-else-if="
          condamnation.Raison_sociale ==null && condamnation.Nom_exploitant != null
        "
      >
        <h3>{{ condamnation.Nom_exploitant }}</h3>
      </hgroup>
      <hgroup
        v-else-if="
          condamnation.Raison_sociale != null && condamnation.Nom_exploitant == null
        "
      >
        <h3>{{ condamnation.Raison_sociale }}</h3>
      </hgroup>

      <p class="petite_majuscule" v-if="condamnation.Adresse_lieu_infraction">
        {{ condamnation.Adresse_lieu_infraction }}
      </p>
      <p class="petite_majuscule" v-if="condamnation.Description_infraction">
        {{ condamnation.Description_infraction }}
      </p>
      <p v-if="condamnation.Amende">
        <strong>Amende : {{ condamnation.Amende }}</strong>
      </p>
      <div
        v-if="condamnation.Information_etablissement"
        class="mention-precision"
      >
        <p
          class="etablissementFermer"
          v-if="condamnation.Information_etablissement"
        >
          {{ condamnation.Information_etablissement }}
        </p>
        <aside
          v-if="condamnation.Information_etablissement"
          class="mention-tooltips tooltips_container"
        >
          <button
            aria-controls="Infobulle_filtre"
            aria-label="Afficher information supplémentaire"
            class="button-info"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 16 16"
              enable-background="new 0 0 16 16"
              xml:space="preserve"
            >
              <desc>Icône pour afficher de l'information supplémentaire</desc>
              <path
                d="M8,16c4.4,0,8-3.6,8-8s-3.6-8-8-8S0,3.6,0,8S3.6,16,8,16z M8.9,6.6l-1,4.7c-0.1,0.3,0,0.5,0.3,0.5
									c0.2,0,0.5-0.1,0.7-0.2L8.8,12c-0.3,0.3-0.9,0.6-1.5,0.6c-0.7,0-1-0.4-0.8-1.3l0.7-3.5c0.1-0.3,0-0.4-0.3-0.5L6.6,7.3l0.1-0.4
									L8.9,6.6L8.9,6.6z M8,5.5c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,5.5,8,5.5z"
              ></path>
            </svg>
          </button>
          <div id="Infobulle_mention" role="tooltip" class="tooltips_info">
            <div>
              <p>
                La mention signifie : l’exploitant (une compagnie, une société
                ou une personne) qui tenait le commerce ou le lieu de garde au
                moment de l’infraction n’exerce plus d’activité au lieu où
                l’infraction a été commise. Cependant, l’exploitant a pu
                utiliser le même endroit pour y exploiter un nouveau commerce ou
                lieu de garde, du même type ou non, et ce, parfois sous le même
                nom.
              </p>
            </div>
            <button
              aria-controls="Infobulle_mention"
              aria-label="Fermer information supplémentaire"
              class="button-info-fermer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#095797"
                viewBox="0 0 16 16"
                class="bi bi-x"
              >
                <desc>
                  Icône pour fermer la boite d'information supplémentaire
                </desc>
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                ></path>
              </svg>
            </button>
          </div>
          <div aria-hidden="true" class="tooltip_arrow">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16">
              <path d="M16 0l16 16H0z"></path>
            </svg>
          </div>
        </aside>
      </div>

      <p class="small" v-if="condamnation.Type_etablissement">
        {{ condamnation.Type_etablissement }}
      </p>

      <p class="small" style="" v-if="condamnation.Date_jugement">
        Date de publication :
        {{ condamnation.Date_publication.toString().substring(0, 10) }}
      </p>
    </div>
  </div>
</template>

<script>
//import Condamnation from './Condamnation'

export default {
  name: 'Condamnations',
  props: {
    nbrResultats: {
      type: Number,
    },
    isFetching: {
      type: Boolean,
    },
    condamnations: {
      type: Array,
    },
    filtres: {
      type: Object,
    },
    pageCourante: {
      type: Number,
    },
  },
  computed: {
    PaginationCond() {
      return this.condamnations.slice(
        (this.pageCourante - 1) * this.nbrResultats,
        this.pageCourante * this.nbrResultats
      );
    },
  },
};
</script>
